import {createContext, memo, use, useMemo} from 'react'

import {useHandlePaginatedDataRefresh} from '../../data-refresh/use-handle-paginated-data-refresh'

type PaginatedMemexItemsQueryContextType = {
  handlePaginatedDataRefresh: ReturnType<typeof useHandlePaginatedDataRefresh>['handleRefresh']
  isRefreshing: boolean
}

const PaginatedMemexItemsQueryContext = createContext<PaginatedMemexItemsQueryContextType | null>(null)

export const PaginatedMemexItemsQueryProvider = memo(function PaginatedMemexItemsQueryProviderComponent({
  children,
}: {
  children: React.ReactNode
}) {
  const {handleRefresh: handlePaginatedDataRefresh, isRefreshing} = useHandlePaginatedDataRefresh()

  const value = useMemo(() => {
    return {
      handlePaginatedDataRefresh,
      isRefreshing,
    }
  }, [handlePaginatedDataRefresh, isRefreshing])

  return <PaginatedMemexItemsQueryContext value={value}>{children}</PaginatedMemexItemsQueryContext>
})

export const usePaginatedMemexItemsQueryContext = () => use(PaginatedMemexItemsQueryContext)
